import { css } from '@eti/styles';
import { Stack } from '@etg/wings';
import type { TicketV4Props } from '../../model';
import { TicketCardV4 } from '../cards/TicketCardV4';

const ticketsWrapperStyles = css`
  background-color: #fff;
  border-radius: 0;
  bottom: 0;
  box-shadow: 0 -2px 8px 0 #0000000d;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 10;
`;

export const TicketV4 = ({
  isLoading,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  onClick,
  tickets,
  selectedTicketType,
  ticketPriceModalInfo,
}: TicketV4Props) => {
  const isMultipleTickets = tickets?.length > 1;

  return (
    <Stack className={ticketsWrapperStyles} data-testid="ticket-version-4" spacing={8}>
      {tickets?.map((ticket, index) => (
        <TicketCardV4
          index={index}
          isLoading={isLoading}
          isMultipleTickets={isMultipleTickets}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          key={ticket.ticketType}
          onClick={onClick}
          selectedTicketType={selectedTicketType}
          ticket={ticket}
          ticketPriceModalInfo={ticketPriceModalInfo}
        />
      ))}
    </Stack>
  );
};
